// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__3eqmP","footer":"ChangeClinic_footer__39ZJ8"};